// extracted by mini-css-extract-plugin
export default {"main1":"Main_main1__+TY9c","main101":"Main_main101__ts+U9"};